import styled, { css } from 'styled-components';

export const Container = styled.div`
  height: 24px;
  width: fit-content;

  display: flex;
  align-items: center;
  justify-content: center;

  user-select: none;

  ${({ theme }) => css`
    padding: 0 ${theme.padding.smallest};
    border-radius: ${theme.borderRadius.default};
  `}
`;
